import { render, staticRenderFns } from "./FullPagePublicStudentDashboard.vue?vue&type=template&id=114961d8&"
import script from "./FullPagePublicStudentDashboard.vue?vue&type=script&lang=js&"
export * from "./FullPagePublicStudentDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports